export default {
  data: () => ({
    translations: {
      title_points: {
        el: 'Λήξη Πόντων',
        en: 'Point Expiration',
        it: 'Scadenza dei punti',
      },
      title_cashback: {
        el: 'Λήξη Cashback',
        en: 'Cashback Expiration',
        it: 'Scadenza del Cashback',
      },
      description1_points: {
        el: 'Μηδενισμός πόντων μετά από ',
        en: 'Nullification of points after ',
        it: 'Azzeramento dei punti dopo ',
      },

      description1_cashback: {
        el: 'Μηδενισμός cashback μετά από ',
        en: 'Nullification of cashback after ',
        it: 'Azzeramento del cashback dopo ',
      },
      description2: {
        el: ' ανενεργές ημέρες του χρήστη.',
        en: ' inactive days of the user.',
        it: " giorni di inattività dell'utente.",
      },
      numberOfDays: {
        el: 'Ημέρες',
        en: 'Days',
        it: 'Giorni',
      },
      type0forInfinite: {
        el: 'Για να μην υπάρχει λήξη, εισάγετε 0',
        en: 'For no expiration, type 0 ',
        it: 'Per non avere scadenze, digitare 0 ',
      },
      neverExpire_points: {
        el: 'Οι πόντοι δεν λήγουν <b>ποτέ</b>.',
        en: 'The points will <b>never</b> expire.',
        it: 'I punti non scadranno <b>mai</b>.',
      },
      neverExpire_cashback: {
        el: 'Το cashback δεν λήγει <b>ποτέ</b>.',
        en: 'The cashback will <b>never</b> expire.',
        it: 'Il cashback non scadrà <b>mai</b>.',
      },
    },
  }),
};
